import { put } from 'redux-saga/effects';

import Instance from 'providers/instance';
import { paymentEndpoint as endpoint } from 'providers/endpoints/payment';
import {
  actions,
  putMaybankCardTac,
  putCreditCardTypes,
  putCreditCardAccess,
  putOtherBankCardTac,
  putMaybankCardResult,
  putMaybankCardReceipt,
  putOtherBankCardResult,
  putOtherBankCardReceipt,
  putCreditCardMaybankAccess,
  putMaybankCardConfirmation,
  putCreditCardMaybankHolders,
  putOtherBankCardConfirmation,
} from 'middleware/actions/payment';
import { actions as favouriteActions } from 'middleware/actions/favourite/payment';

const getAccess = ({ body }) => Instance.post(endpoint.creditCard.getAccess, body);
const getMaybankAccess = ({ body }) => Instance.post(endpoint.creditCard.getMaybankAccess, body);
const getMaybankConfirmation = ({ body }) => Instance.post(endpoint.creditCard.getMaybankConfirmation, body);
const getOtherBankConfirmation = ({ body }) => Instance.post(endpoint.creditCard.getOtherBankConfirmation, body);
const requestMaybankTac = ({ body }) => Instance.post(endpoint.creditCard.requestMaybankTac, body);
const requestOtherBankTac = ({ body }) => Instance.post(endpoint.creditCard.requestOtherBankTac, body);
const getMaybankResult = ({ body }) => Instance.post(endpoint.creditCard.getMaybankResult, body);
const getOtherBankResult = ({ body }) => Instance.post(endpoint.creditCard.getOtherBankResult, body);
const getMaybankReceipt = ({ body }) => Instance.post(endpoint.creditCard.getMaybankReceipt, body);
const getOtherBankReceipt = ({ body }) => Instance.post(endpoint.creditCard.getOtherBankReceipt, body);
const requestMaybankFavTac = ({ body }) => Instance.post(endpoint.creditCard.favourite.payment.getMaybankTac, body);
const requestOtherBankFavTac = ({ body }) => Instance.post(endpoint.creditCard.favourite.payment.getOtherTac, body);

const {
  ACCESS,
  MAYBANK_ACCESS,
  MAYBANK_RESULT,
  MAYBANK_RECEIPT,
  OTHER_BANK_RESULT,
  OTHER_BANK_RECEIPT,
  REQUEST_MAYBANK_TAC,
  MAYBANK_CONFIRMATION,
  REQUEST_OTHER_BANK_TAC,
  OTHER_BANK_CONFIRMATION,
} = actions.GET.CREDIT_CARD;

const {
  MAYBANK_CONFIRM: FAV_MAYBANK_CONFIRM,
  OTHER_CONFIRM: FAV_OTHER_CONFIRM,
  MAYBANK_TAC: FAV_MAYBANK_TAC,
  OTHER_TAC: FAV_OTHER_TAC,
  MAYBANK_RECEIPT: FAV_MAYBANK_RECEIPT,
  OTHER_RECEIPT: FAV_OTHER_RECEIPT,
} = favouriteActions.GET.CREDIT_CARD.PAYMENT_FROM_FAVOURITE;

export const ccCallAccessHandler = type => {
  const handler = {
    [ACCESS]: () => getAccess,
    [MAYBANK_ACCESS]: () => getMaybankAccess,
    default: () => null,
  };

  return (handler[type] || handler.default)();
};

export const ccPutAccessHandler = ({ type, access, billers }) => {
  const handler = {
    [ACCESS]: () => [put(putCreditCardAccess(access)), put(putCreditCardTypes(billers))],
    [MAYBANK_ACCESS]: () => [put(putCreditCardMaybankAccess(access)), put(putCreditCardMaybankHolders(billers))],
    default: () => null,
  };

  return (handler[type] || handler.default)();
};

export const ccCallConfirmationHandler = type => {
  const handler = {
    [MAYBANK_CONFIRMATION]: () => getMaybankConfirmation,
    [FAV_MAYBANK_CONFIRM]: () => getMaybankConfirmation,
    [OTHER_BANK_CONFIRMATION]: () => getOtherBankConfirmation,
    [FAV_OTHER_CONFIRM]: () => getOtherBankConfirmation,
    default: () => console.error('call confirmation handler not found'),
  };
  return (handler[type] || handler.default)();
};

export const ccPutConfirmationHandler = (type, data) => {
  const handler = {
    [MAYBANK_CONFIRMATION]: () => putMaybankCardConfirmation(data),
    [OTHER_BANK_CONFIRMATION]: () => putOtherBankCardConfirmation(data),
    default: () => console.error('put confirmation handler not found'),
  };

  return (handler[type] || handler.default)();
};

export const ccCallTacHandler = type => {
  const handler = {
    [REQUEST_MAYBANK_TAC]: () => requestMaybankTac,
    [REQUEST_OTHER_BANK_TAC]: () => requestOtherBankTac,
    [FAV_MAYBANK_TAC]: () => requestMaybankFavTac,
    [FAV_OTHER_TAC]: () => requestOtherBankFavTac,
    default: () => console.error('call TAC handler not found'),
  };
  return (handler[type] || handler.default)();
};

export const ccPutTacHandler = (type, data) => {
  const handler = {
    [REQUEST_MAYBANK_TAC]: () => putMaybankCardTac(data),
    [REQUEST_OTHER_BANK_TAC]: () => putOtherBankCardTac(data),
    [FAV_MAYBANK_TAC]: () => putMaybankCardTac(data),
    [FAV_OTHER_TAC]: () => putOtherBankCardTac(data),
    default: () => console.error('put confirmation handler not found'),
  };

  return (handler[type] || handler.default)();
};

export const ccCallResultHandler = type => {
  const handler = {
    [MAYBANK_RESULT]: () => getMaybankResult,
    [OTHER_BANK_RESULT]: () => getOtherBankResult,
    default: () => console.error('call Resul handler not found'),
  };
  return (handler[type] || handler.default)();
};

export const ccPutResultHandler = (type, data) => {
  const handler = {
    [MAYBANK_RESULT]: () => putMaybankCardResult(data),
    [OTHER_BANK_RESULT]: () => putOtherBankCardResult(data),
    default: () => console.error('put Resul handler not found'),
  };

  return (handler[type] || handler.default)();
};

export const ccCallReceiptHandler = type => {
  const handler = {
    [MAYBANK_RECEIPT]: () => getMaybankReceipt,
    [OTHER_BANK_RECEIPT]: () => getOtherBankReceipt,
    [FAV_MAYBANK_RECEIPT]: () => getMaybankReceipt,
    [FAV_OTHER_RECEIPT]: () => getOtherBankReceipt,
    default: () => console.error('call Receipt handler not found'),
  };
  return (handler[type] || handler.default)();
};

export const ccPutReceiptHandler = (type, data) => {
  const handler = {
    [MAYBANK_RECEIPT]: () => putMaybankCardReceipt(data),
    [OTHER_BANK_RECEIPT]: () => putOtherBankCardReceipt(data),
    [FAV_MAYBANK_RECEIPT]: () => putMaybankCardReceipt(data),
    [FAV_OTHER_RECEIPT]: () => putOtherBankCardReceipt(data),
    default: () => console.error('put Receipt handler not found'),
  };
  return (handler[type] || handler.default)();
};
